/**
 * LEGACY FIXED VALUES
 */

export const segments = [
    'PAP MIXTE',
    'PAP HOMME',
    'PAP FEMME',
    'PAP ENFANT',
    'ACCESSOIRES',
    'CHAUSSURES',
    'EPICERIE FINE',
    'JEANSWEAR',
    'AUTRE',
    'LINGERIE',
    'MAISON',
    'RESTAURATION',
    'SPORT',
]

export const days = [
    { text: 'Lundi', value: 1 },
    { text: 'Mardi', value: 2 },
    { text: 'Mercredi', value: 3 },
    { text: 'Jeudi', value: 4 },
    { text: 'Vendredi', value: 5 },
    { text: 'Samedi', value: 6 },
    { text: 'Dimanche', value: 0 }
]
